import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";
import { usePractice } from "@/pages/StaffApp";
import { CheckList } from "@/components/ProviderFacilities";

export const RD_LEVELS = [["view", "View and report only"], ["work", "View and work like a coordinator"], ["admin", "Full admin for their group"]];

export default function GroupDialog({ member, onClose, onSaved }) {
  const { practice } = usePractice();
  const [g, setG] = useState({ provider_codes: [], facility_codes: [], rd_level: "view" });
  useEffect(() => { if (member) setG({ provider_codes: member.provider_codes || [], facility_codes: member.facility_codes || [], rd_level: member.rd_level || "view" }); }, [member]);
  const save = async () => {
    try { await api.patch(`/practice/members/${member.id}`, g); toast.success("Group saved (audited)"); onSaved(); onClose(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!member} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="group-dialog">
        <DialogHeader><DialogTitle>Regional director group - {member?.name}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div><p className="text-sm font-medium mb-1">Access level</p>
            <Select value={g.rd_level} onValueChange={(v) => setG({ ...g, rd_level: v })}><SelectTrigger data-testid="group-level"><SelectValue /></SelectTrigger>
              <SelectContent>{RD_LEVELS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent></Select></div>
          <div><p className="text-sm font-medium mb-1">Providers in group ({g.provider_codes.length}) - their mapped facilities are included automatically</p>
            <CheckList items={practice.providers} value={g.provider_codes} onChange={(v) => setG({ ...g, provider_codes: v })} testid="group-provider" /></div>
          <div><p className="text-sm font-medium mb-1">Extra facilities in group ({g.facility_codes.length})</p>
            <CheckList items={practice.facilities} value={g.facility_codes} onChange={(v) => setG({ ...g, facility_codes: v })} testid="group-facility" /></div>
          <Button className="btn-brand w-full" onClick={save} data-testid="group-save">Save group</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
